/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

import template from './invoice-translation-list-page.component.html';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../common/controller/signal-admin-resource-list-state';
import {InvoiceTranslationApiService, InvoiceTranslationModel} from './invoice-translation-api.service';
import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-invoice-translation-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceTranslationListPageComponent implements OnInit {
  readonly itemStateName = 'app.rep.invoice-translations.invoice-translation';
  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'locale', param: '', sortable: false}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<InvoiceTranslationModel>(
    inject(InvoiceTranslationApiService),
    {listId: 'fullInvoiceTranslationList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
